const FORMSPREE_ENDPOINT = 'https://formspree.io/f/mvkgpryw';

export async function submitContactForm(
  data: Record<string, string | boolean>
): Promise<boolean> {
  const body = {
    ...data,
    _subject: 'Neue Kontaktanfrage über optiai.at',
  };

  try {
    const res = await fetch(FORMSPREE_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    });
    return res.ok;
  } catch {
    return false;
  }
}
